module.exports = __webpack_public_path__ + "img/kid-btn.174b30ba.svg";